import { createFileRoute } from '@tanstack/react-router'
import { LogoEmsInlineColor } from '@/components'
import MainPageTemplate from '@/components/layout/page-templates/main/MainPageTemplate'

export const Route = createFileRoute('/_ems')({
  component: () => (
    <MainPageTemplate header={{ logo: LogoEmsInlineColor, logoRoute: null }} />
  ),
})
